import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () =>
      import('src/app/features/home/home.module').then((mod) => mod.HomeModule),
  },
  {
    path: 'promotion',
    loadChildren: () =>
      import('src/app/features/promotion/promotion.module').then(
        (mod) => mod.PromotionModule
      ),
  },
  {
    path: 'advanced-report',
    loadChildren: () =>
      import('src/app/features/advanced-report/advanced-report.module').then(
        (mod) => mod.AdvancedReportModule
      ),
  },
  {
    path: 'tools',
    loadChildren: () =>
      import('src/app/features/tools/tools.module').then((mod) => mod.ToolsModule),
  },
  {
    path: 'create-batch',
    loadChildren: () =>
      import('src/app/features/create-batch/create-batch.module').then(
        (mod) => mod.CreateBatchModule
      ),
  },
  {
    path: 'create-campaign-v2',
    loadComponent: () =>
      import('src/app/features/create-campaign-v2/create-campaign-v2.component').then(
        (mod) => mod.CreateCampaignV2Component
      ),
  },
  {
    path: 'create-campaign-pro',
    loadComponent: () =>
      import('src/app/features/create-campaign-pro/create-campaign-pro.component').then(
        (mod) => mod.CreateCampaignProComponent
      ),
  },
  {
    path: 'create-unit',
    loadChildren: () =>
      import('src/app/features/create-unit/create-unit.module').then(
        (mod) => mod.CreateUnitModule
      ),
  },
  {
    path: 'task-list',
    loadChildren: () =>
      import('src/app/features/task-list/task-list.module').then(
        (mod) => mod.TaskListModule
      ),
  },
  {
    path: 'report',
    loadChildren: () =>
      import('src/app/features/report/report.module').then((mod) => mod.ReportModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
